<template>
  <div class="search">
    <form action="/" class="form-flex">
      <van-search v-model="value" right-icon="" :placeholder="searchTips" @search="onCourseSearchEnter"
                  :clearable="true" clear-trigger="always" @clear="clearSearchValue">
        <template #left-icon>
          <div>
            <van-icon name="search"/>
          </div>
        </template>
      </van-search>
    </form>
  </div>
</template>

<script>
import {handleTraceSearchLog} from '../../../utils/trace'

export default {
  name: 'database-search',
  data() {
    return {
      value: ''
    }
  },
  props: {
    searchTips: {
      type: String,
      default: '请输入课程名称、讲师、医院搜索'
    },
    searchValue: {
      type: String,
      default: ''
    }
  },
  watch: {
    value: function (val) {
      this.$emit('input', val)
    },
    searchValue: function (val) {
      this.value = val
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    async onCourseSearchEnter() {
      handleTraceSearchLog({
        'userId': this.userInfo.id,
        'searchContent': this.value,
        'sessionId': localStorage.getItem('sessionId'),
        'type': 5,
        'entrance': 11,
      })
      this.$emit('onSearchEnter')
    },
    clearSearchValue() {
      this.$emit('input', '')
      this.$emit('clearSearchValue')
    }
  },
  model: {
    prop: 'searchValue',
    event: 'input'
  }
}
</script>

<style lang="less" scoped>
.van-search {
  .van-search__content {
    background: #F9F8F7;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/database/modules/DatabaseSearch.vue